import { indexOf } from 'underscore';
import BaseAPI from '../../utils/api/base_api';

export const sortCategoryByName = (array) => {
    return array.sort((a, b) => {
        if (a.category.toLowerCase() < b.category.toLowerCase()) {
            return -1;
        }
        if (a.category.toLowerCase() > b.category.toLowerCase()) {
            return 1;
        }
        return 0;
    });
};

export const sortCompaniesByName = (array) => {
    return array.sort((a, b) => {
        if (a.company_name.toLowerCase() < b.company_name.toLowerCase()) {
            return -1;
        }
        if (a.company_name.toLowerCase() > b.company_name.toLowerCase()) {
            return 1;
        }
        return 0;
    });
};

export const getQuestionnaireIdByName = (data, name) => {
    return data.filter((data) => data.test_name === name)[0].id;
};

export const getDataById = async (vendor_id, questionnaireId) => {
    return await BaseAPI.get(
        `exam_tests/${questionnaireId}/vox_questionnaire`,
        {
            params: {
                vendor_id,
            },
        }
    );
};

export const getVendorDataByQuestionnaireId = async (
    vendorList,
    questionnaireId
) => {
    const info = await vendorList.map(async (vendor) => {
        const newData = await getDataById(vendor.vendor_id, questionnaireId);
        return await {
            ...newData.data,
            id: vendor.vendor_id,
            company_name: vendor.company_name,
        };
    });

    const newInfo = await info;
    if (newInfo) {
        return await Promise.all(newInfo);
    }
};

export const createArrayFromQuestionnaireNoSubs = (data) => {
    // Creates an array of objects used to fill out progress bar for questionnaires
    if (data) {
        const progress = data.map((object) => {
            const progObject = Object.keys(object.header.categories).map(
                (key) => {
                    const {
                        total_anwers,
                        total_questions,
                        title,
                    } = object.header.categories[key];

                    return {
                        totalCompleted: total_anwers,
                        totalCorrect: total_anwers,
                        grandTotal: total_questions,
                        title: title,
                        id: object.id,
                    };
                }
            );
            return progObject;
        });

        return progress;
    }
};

export const createArrayWithCompletionTotals = (
    gapAnalysisResponsesVendor,
    statusReportResponsesVendor
) => {
    const gapInfoForDisplay = gapAnalysisResponsesVendor.map((object) => {
        return {
            totalCompleted: object.header.total_anwers || 0,
            totalCorrect: object.header.total_correct_anwers || 0,
            grandTotal: object.header.total_questions || 0,
            id: object.id,
            title: object.company_name || '',
        };
    });

    const statusInfoForDisplay = statusReportResponsesVendor.map((object) => {
        return {
            totalCompleted: object.header.total_anwers || 0,
            totalCorrect: object.header.total_correct_anwers || 0,
            grandTotal: object.header.total_questions || 0,
            id: object.id,
            title: object.company_name || '',
        };
    });

    const bothCategoryTotals = gapInfoForDisplay
        .map(
            (
                {
                    totalCompleted,
                    totalCorrect,
                    grandTotal,
                    id,
                    title,
                    companyType,
                },
                index
            ) => {
                const statusInfo = statusInfoForDisplay[index];

                return {
                    grandTotal: grandTotal + statusInfo.grandTotal,
                    totalCompleted: totalCompleted + statusInfo.totalCompleted,
                    totalCorrect: totalCorrect + statusInfo.totalCorrect,
                    id: id || '',
                    title,
                    companyType,
                };
            }
        )
        .sort((a, b) => {
            if (a.title < b.title) {
                return -1;
            }
            if (a.title > b.title) {
                return 1;
            }
            return 0;
        });

    return bothCategoryTotals;
};

/****
 * Will return the category that "owns" a subcategory by passing in the category id that
 * is in the currently selected subcategory
 */
export const matchCategoryAndSubcategory = (categories, categoryId) => {
    return categories.fitler((category) => category.id === categoryId)[0];
};



// WEBPACK FOOTER //
// ./src/redux/vendor/utils.js